import baseURL from "../config/api";
import axios from "../config/axios";


export const post_Quize = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}quizzes?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_QuizRelatedExcerices = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}quizRelatedExercises?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_Quize = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}quizzes?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}


export const delete_Question = (questionId: number, userId:number) => {
    return axios({
        url: `${baseURL}questions?id=${questionId}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}

export const delete_Answer = (answerId: number, userId:number) => {
    return axios({
        url: `${baseURL}answers?id=${answerId}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}


export const delete_Quiz = (primaryId: number, userId:number) => {
    return axios({
        url: `${baseURL}quizzes?id=${primaryId}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}


export const getQuizeBySubLesson = (subLessonId: number) => {
    return getFetch(`quizzes/GetQuizzesNotRelatedExercisesBySubLessonId/${subLessonId}`);
}


const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}